export class Score {
    level: number = 1
    value: number = 0
}